// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import cx from 'classnames';
import styles from './styles.module.scss';
import RoutedPaginationLinks from 'shared/components/RoutedPaginationLinks';
import uid from 'uid';

const Wrapper = props => (
  <Page title="Login Attempts">
    <Row>
      <Widget title="Login Attempts" span={12}>
        <IndexPage {...props} />
      </Widget>
    </Row>
  </Page>
);

class IndexPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loginAttempts: null,
      totalPages: null,
      pageNum: null,
    };
  }

  componentDidMount() {
    this.fetchPage(this.props);
  }

  componentDidUpdate(prevProps) {
    const desiredPageNum = parseInt(this.props.location.query.page_num || 1);
    const prevPageNum = parseInt(prevProps.location.query.page_num || 1);
    if (prevPageNum !== desiredPageNum) {
      this.fetchPage(this.props);
    }
  }

  fetchPage(props) {
    const desiredPageNum = parseInt(props.location.query.page_num || 1);
    if (desiredPageNum !== this.state.pageNum) {
      const requestId = uid();
      this.setState({ loginAttempts: null, requestId });
      api
        .get(`/agent_portal/api/agents/${this.props.params.agent_id}/login_attempts`, {
          params: {
            page: desiredPageNum,
          },
        })
        .then(response => {
          if (requestId === this.state.requestId) {
            this.setState({
              loginAttempts: response.data.attempts,
              totalPages: response.data.totalPages,
              pageNum: response.data.pageNum,
            });
          }
        });
    }
  }

  render() {
    if (!this.state.loginAttempts) return <LoadingContent />;

    return (
      <div>
        <table className="table table-bordered table-striped table-hover data-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Type</th>
              <th>IP</th>
              <th>IP Info (hover)</th>
              <th>Browser</th>
            </tr>
          </thead>
          <tbody>
            {this.state.loginAttempts.map(attempt => (
              <tr
                className={cx({
                  [styles.failure]: !attempt.successful,
                  [styles.successful]: attempt.successful,
                })}
              >
                <td>{attempt.createdAt}</td>
                <td>{attempt.successful ? 'Success' : 'Failure'}</td>
                <td>{attempt.ipAddress}</td>
                <td>
                  <span
                    data-tip={JSON.stringify(attempt.ipInfo, null, ' ')}
                    className={cx('dataTooltip', styles.ipInfo)}
                  >
                    {attempt.ipInfo ? attempt.ipInfo.regionName : 'Unknown'}
                  </span>
                </td>
                <td>
                  <span data-tip={attempt.userAgent} className="dataTooltip">
                    {attempt.browserName} {attempt.deviceName} {attempt.platformName}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <RoutedPaginationLinks
          totalPages={this.state.totalPages}
          currentLocation={this.props.location}
        />
      </div>
    );
  }
}

export default Wrapper;
